import React, { useState } from 'react';
import { CheckCircleIcon, MicIcon } from 'lucide-react';
import { ChatInput } from './ChatInput';
import { NotificationButton } from './NotificationButton';
import { RightPanel } from './RightPanel';
import { PerformanceView } from './PerformanceView';
interface InitialViewProps {
  onSendMessage: (message: string) => void;
  isVoiceMode: boolean;
  onToggleVoiceMode: () => void;
}
export const InitialView = ({
  onSendMessage,
  isVoiceMode,
  onToggleVoiceMode
}: InitialViewProps) => {
  const [isPerformancePanelOpen, setIsPerformancePanelOpen] = useState(false);
  return <>
      <div className="flex-grow flex flex-col justify-center items-center p-6 md:p-8 overflow-auto" style={{
      backgroundImage: 'radial-gradient(circle at center, #2d4c6b 0%, #1f1f1f 100%)'
    }} data-id="element-123">
        <div className="absolute top-6 right-6" data-id="element-124">
          <NotificationButton data-id="element-125" />
        </div>
        <h1 className="text-2xl md:text-3xl font-semibold text-[#a0a0a0] mb-8 flex items-center gap-3" data-id="element-126">
          <span data-id="element-127">
            {isVoiceMode ? "I'm listening..." : 'How can I help you today?'}
          </span>
        </h1>
        <button onClick={onToggleVoiceMode} className="mb-8 p-6 rounded-full bg-[#1f1f1f] border-2 border-[#444444] hover:border-[#4a90e2] transition-all duration-200 relative group" data-id="element-128">
          <div className={`p-4 rounded-full ${isVoiceMode ? 'bg-[#4a90e2]' : 'bg-[#2d2d2d] hover:bg-[#3a3a3a]'} transition-colors`} data-id="element-129">
            <MicIcon size={32} className={isVoiceMode ? 'text-white' : 'text-[#e0e0e0]'} data-id="element-130" />
          </div>
          {isVoiceMode && <>
              <div className="absolute inset-0 rounded-full animate-ping-slow bg-[#4a90e2] opacity-20" data-id="element-131"></div>
              <div className="absolute inset-0 rounded-full animate-ping-slow delay-300 bg-[#4a90e2] opacity-20" data-id="element-132"></div>
            </>}
        </button>
        {!isVoiceMode && <div className="w-full max-w-[800px]" data-id="element-133">
            <ChatInput onSendMessage={onSendMessage} data-id="element-134" />
          </div>}
      </div>
      <RightPanel isOpen={isPerformancePanelOpen} onClose={() => setIsPerformancePanelOpen(false)} data-id="element-135">
        <PerformanceView data-id="element-136" />
      </RightPanel>
    </>;
};